import React from "react"
import { makeStyles } from '@material-ui/core/styles';

import mixin from '../utils/mixin'
import WeatherIcon from "./weather-icon";

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  yoho: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  week: {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(2),
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  }
}));

export const ContentWeather = ({ data }) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState(false);

  const handleClickOpen = (title, content) => {
    setOpen(true);
    setDialogContent(content);
    setDialogTitle(title)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const timeFormat = (string) => {
    return `〜${string.split("～")[1]}`
  }

  // MEMO 今日明日発表時間
  const yohoRepTime = data.loc.rpt_yoho_date ? mixin.formatDate(data.loc.rpt_yoho_date) : mixin.formatDate(data.loc.rpt_date);
  const yohoTitle = ["今日", "明日", "明後日"];
  const yoho = data.loc.yoho.map((a, i) => (
        <React.Fragment key={`weather-yoho-${i}`}>
          <Grid
            spacing={0}
            container
            align="center"
            alignItems="center"

            className={classes.content}
           >
            <Grid item xs={2} sm={2}>
              <Typography variant="body1" component="p">
                <strong>{yohoTitle[i]}</strong>
              </Typography>
              <Typography variant="inherit" component="p">
                {mixin.formatDate(a["-date"], true)}
              </Typography>
              <Typography variant="inherit" component="p">
                {mixin.formatWeekDay(a["-date"], true)}
              </Typography>

            </Grid>
            <Grid item xs={3} sm={3} >
              { a["wx"] && a["wx"]["-code"] ? (
                <WeatherIcon src={`weather/${a["wx"]["-code"]}.png`} />
                ) : (
                <WeatherIcon src={`weather/000.png`} />
              )}
              <Typography variant="inherit" component="span">
                { a["wx"] && a["wx"]["#text"] && a["wx"]["#text"] }
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2}>
              <Typography variant="body1" component="div" color="error">
                { a["temp"] && a["temp"]["-high"] ? a["temp"]["-high"] : "-" }
              </Typography>
              <Typography variant="body1" component="div" color="primary">
                { a["temp"] && a["temp"]["-low"] ? a["temp"]["-low"] : "-" }
              </Typography>
              { /*<Typography variant="body1" component="span">  ℃</Typography>*/}
            </Grid>
            <Grid item xs={4} sm={4}>
              { a["prec"] && a["prec"].map((data, i) => (
                <React.Fragment key={`prec-${i}`}>
                  <Typography variant="inherit" component="span">
                    { `${timeFormat(data["-time"])}：`}
                  </Typography>
                  <Typography variant="inherit" component="span" color="primary">
                    { `${data["-val"]} `}
                  </Typography>
                  <Typography variant="inherit" component="span">
                    %
                  </Typography>
                  <br />
                </React.Fragment>
              ))}
            </Grid>
            <Grid item xs={1} sm={1}>
              <IconButton onClick={() => handleClickOpen(yohoTitle[i], a)}>
                <InfoIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Divider />
        </React.Fragment>
      ))
  // MEMO 週間発表時間
  const weekRepTime = mixin.formatDate(data.loc.rpt_date);
  const week = data.loc.week.map((a, i) => {
        return(
          <React.Fragment key={`weather-week-${i}`}>
            <Grid
              spacing={3}
              container
              align="center"
              alignItems="center"

              className={classes.content}
             >
              <Grid item xs={2} sm={2}>
                <Typography variant="body1" component="p">
                  <strong>{mixin.formatDate(a["-datetime"], true)}</strong>
                </Typography>
                <Typography variant="inherit" component="p">
                  {mixin.formatWeekDay(a["-datetime"], true)}
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} >
                { a["wx"] && a["wx"]["-code"] ? (
                  <WeatherIcon src={`weather/${a["wx"]["-code"]}.png`} />
                  ) : (
                  <WeatherIcon src={`weather/000.png`} />
                )}
                <Typography variant="inherit" component="p">
                  { a["wx"] && a["wx"]["#text"] && a["wx"]["#text"] }
                </Typography>
              </Grid>
              <Grid item xs={4} sm={4}>
                <Typography variant="body1" component="span" color="error">
                  { a["htmp"] ? a["htmp"] : "-" }
                </Typography>
                <Typography variant="body1" component="span"> / </Typography>
                <Typography variant="body1" component="span" color="primary">
                  { a["ltmp"] ? a["ltmp"] : "-" }
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3}>
                <Typography variant="inherit" component="span" color="primary">
                  { a["prec"] ? a["prec"] : "-"}
                </Typography>
                <Typography variant="inherit" component="span">
                  { " %" }
                </Typography>
              </Grid>
            </Grid>
            <Divider />
          </React.Fragment>
        )
  });
  return (
    <React.Fragment>
      <div id="yoho" className={classes.yoho}>
        <Typography variant="body1" component="p">今日・明日の予報（{yohoRepTime} 発表）</Typography>
        <Divider />
        <Grid
          spacing={0}
          container
          align="center"
          alignItems="center"

          className={classes.content}
        >
          <Grid item xs={2} sm={2}>
          </Grid>
          <Grid item xs={3} sm={3} >
            <Typography variant="inherit" component="div">
              予報
            </Typography>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Typography variant="inherit" component="div">
              気温
            </Typography>
            { /*<Typography variant="body1" component="span">  ℃</Typography>*/}
          </Grid>
          <Grid item xs={4} sm={4}>
            <Typography variant="inherit" component="div">
              降水確率
            </Typography>
          </Grid>
          <Grid item xs={1} sm={1}>
          </Grid>
        </Grid>

        <Divider />
        {yoho}
      </div>
      <div id="week" className={classes.week}>
        <Typography variant="body1" component="p">週間予報（{weekRepTime} 発表）</Typography>
        <Divider />
        <Grid
          spacing={3}
          container
          align="center"
          alignItems="center"

          className={classes.content}
         >
          <Grid item xs={2} sm={2}>
          </Grid>
          <Grid item xs={3} sm={3} >
            <Typography variant="inherit" component="div">
              予報
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4}>
            <Typography variant="inherit" component="div">
              気温
            </Typography>
          </Grid>
          <Grid item xs={3} sm={3}>
            <Typography variant="inherit" component="div">
              降水確率
            </Typography>
          </Grid>
        </Grid>
        {week}
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}の予報</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <Typography variant="body1" component="div">
              { dialogContent["wx"] && dialogContent["wx"]["#textd"] && dialogContent["wx"]["#textd"].replace(/　/g, "") }
            </Typography>
            <Typography variant="body1" component="div">
              { dialogContent["wind"] && dialogContent["wind"]["#text"] && dialogContent["wind"]["#text"].replace(/　/g, "") }
            </Typography>
            <Typography variant="body1" component="div">
              { dialogContent["wave"] && dialogContent["wave"]["#text"] && dialogContent["wave"]["#text"].replace(/　/g, "") }
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ContentWeather